import React from "react";

/**
 * Practice Ghost Reticle — a big rangefinder target box that lights up green
 * when EVERY room constraint is satisfied. Only visible in Practice Mode so
 * the phantom mystery isn't spoiled during the normal game.
 */
const PracticeReticle = ({ inRange, evTone }) => {
    const color = inRange
        ? "var(--crt-green)"
        : evTone === "warn"
            ? "var(--amber)"
            : "rgba(255, 220, 200, 0.35)";

    // Use longhand border properties only — mixing `borderColor` (shorthand) with
    // `borderTop`/`borderLeft` triggers a React style-conflict warning on re-render.
    const edge = (side) => ({
        [`border${side}Width`]: "2px",
        [`border${side}Style`]: "solid",
        [`border${side}Color`]: color,
    });

    const cornerStyle = (pos) => {
        if (pos === "tl") return { top: 0,    left: 0,  ...edge("Top"),    ...edge("Left") };
        if (pos === "tr") return { top: 0,    right: 0, ...edge("Top"),    ...edge("Right") };
        if (pos === "bl") return { bottom: 0, left: 0,  ...edge("Bottom"), ...edge("Left") };
        return              { bottom: 0, right: 0, ...edge("Bottom"), ...edge("Right") };
    };

    return (
        <div
            className={`pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[2] ${inRange ? "ghost-target-locked" : ""}`}
            style={{ width: "52%", height: "44%" }}
            data-testid="practice-ghost-reticle"
            data-inrange={inRange ? "true" : "false"}
            aria-hidden="true"
        >
            <span className="ghost-target-corner" style={cornerStyle("tl")} />
            <span className="ghost-target-corner" style={cornerStyle("tr")} />
            <span className="ghost-target-corner" style={cornerStyle("bl")} />
            <span className="ghost-target-corner" style={cornerStyle("br")} />
            {inRange && (
                <div
                    className="absolute left-1/2 -bottom-6 -translate-x-1/2 text-[9px] tracking-[0.35em] uppercase font-mono whitespace-nowrap"
                    style={{ color, textShadow: "0 0 10px var(--crt-green)" }}
                    data-testid="practice-ghost-locked"
                >
                    ● Locked
                </div>
            )}
        </div>
    );
};

export default PracticeReticle;
